import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import routes from '../../../../../../components/Routes/routingMap';
import { Creators as cancelRequestActions } from '../../../../../../../domain/useCases/procedures/registerCarnetUseCase/cancelUseCase';
import { Creators as activatePaymentActions } from '../../../../../../../domain/useCases/procedures/registerCarnetUseCase/activateUseCase';

const useGetRequestDetail = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { procedure, request, isLoading, isComplete, isApproved } = useSelector(
    (state: any) => state.procedureStudentStatus
  );
  const profile = useSelector((state: any) => state.profile?.data);
  const procedureStatus = useSelector(
    (state: any) => state.procedureStudentStatus?.procedure?.detail
  );

  const campusId = procedureStatus?.campus;
  const phone = procedureStatus?.contacto;
  const district = procedure?.detail?.district;
  const amountDelivery = 10;
  const deliveryMode = procedureStatus?.deliveryMode;
  const { isLoading: isLoadingCancel, isSuccess: isSuccessCancel } =
    useSelector((state: any) => state.cancelRegisterCarnet);
  const {
    isLoading: isLoadingActivatePayment,
    isSuccess: isSuccessActivatePayment
  } = useSelector((state: any) => state.activateCarnetUniversity);

  const [showModalProgress, setShowModalProgress] = React.useState(false);
  const [showAnulateProgress, setShowAnulateProgress] = React.useState(false);
  const [showActivatedPaymentModal, setShowActivatedPaymentModal] =
    React.useState(false);

  const campusList = [
    { id: 'LIMA', name: 'Lima Centro' },
    { id: 'CHICL', name: 'Chiclayo' },
    { id: 'AREQU', name: 'Arequipa' },
    { id: 'LIMAN', name: 'Lima Norte' },
    { id: 'LISJL', name: 'Lima San Juan de Lurigancho' },
    { id: 'LIATE', name: 'Lima Ate' },
    { id: 'LIMAS', name: 'Lima Sur' },
    { id: 'CHIMB', name: 'Chimbote' },
    { id: 'HUANC', name: 'Huancayo' },
    { id: 'ICA', name: 'Ica' },
    { id: 'PIURA', name: 'Piura' },
    { id: 'TRUJI', name: 'Trujillo' },
    { id: 'VIRT', name: 'Campus UTP' }
  ];

  const campus =
    campusList[campusList.findIndex((c) => c.id === campusId)]?.name;

  const handlerCloseModalProgress = () => {
    setShowModalProgress(false);
    setShowAnulateProgress(false);
    dispatch(activatePaymentActions.activateCarnetUniversityClear());
  };
  const handlerAnnulRequest = (
    requestIdParam: number,
    procedureIdParam: number
  ) => {
    dispatch(
      cancelRequestActions.cancelRegisterCarnet(
        requestIdParam,
        procedureIdParam
      )
    );
  };
  const handlerActivatePayment = () => {
    setShowActivatedPaymentModal(true);
    dispatch(
      activatePaymentActions.activateCarnetUniversity(
        request.id,
        request.procedureId,
        procedureStatus?.deliveryMode,
        profile?.academic?.career
      )
    );
  };
  const handlerOkModalProgress = () => {
    handlerAnnulRequest(request?.id, request?.procedureId);
    history.push(routes.student.procedures.home);
  };
  const handlerShowAnulateProgress = () => {
    setShowAnulateProgress(true);
  };

  React.useEffect(() => {
    if (isSuccessCancel) {
      history.push(routes.student.procedures.home);
    }
  }, [isSuccessCancel]);

  return {
    procedure,
    request,
    isLoading,
    isComplete,
    isApproved,
    showModalProgress,
    isLoadingCancel,
    isLoadingActivatePayment,
    showAnulateProgress,
    isSuccessActivatePayment,
    // handlerStepActionProgress,
    handlerCloseModalProgress,
    handlerOkModalProgress,
    handlerShowAnulateProgress,
    handlerActivatePayment,
    campus,
    phone,
    district,
    amountDelivery,
    deliveryMode,
    showActivatedPaymentModal,
    setShowActivatedPaymentModal
  };
};

export default useGetRequestDetail;
